import gsap from "gsap";
import ListItem from "./list-item";

export default class Minicart {
  constructor() {
    this.isOpen = false;
    this.isupdating = false;
    this.cart_url = document.querySelector("body").dataset.cart;
    this.info_url = document.querySelector("body").dataset.info;
    this.button = document.querySelector("[data-js='minicart']");
    this.total = document.querySelector(".header-cart-total");
    this.closeButton = document.querySelector("[data-js='minicart__close']");
    this.container = document.querySelector("[data-js='minicart__container']");
    this.containerElement = document.querySelector(
      "[data-js='minicart__element']",
    );
    this.containerEls = document.querySelector("[data-js='minicart__els']");

    this.listItemsQuantities = document.querySelectorAll(
      "[data-js='minicart-list-item__quantity']",
    );

    this.cartCounter = document.querySelector("[data-js='header-cart-total']");
    this.subtotal = document.querySelector("[data-js='minicart-subtotal']");

    this.checkOutButton = null;
  }
  updateCart() {
    if (this.isupdating) {
      return false;
    }
    this.isupdating = true;
    fetch(this.cart_url)
      .then((response) => {
        // The API call was successful!
        return response.text();
      })
      .then((html) => {
        console.log("updating")
        this.isupdating = false;
        this.updateCount();

        console.log("count")
        if (html.indexOf("data-removed") > 0) {
          location.reload();
        }

        console.log("removed")
        this.subtotal = document.querySelector("[data-js='minicart-subtotal']");

        console.log("subtotal")
        this.containerEls.innerHTML = html;

        console.log("put elements")
        this.cartActions();

        console.log("actins")
        this.checkOutButton = document.querySelector(
          "[data-js='minicart__checkout']",
        );
        if (this.checkOutButton) {
          this.checkOutButton.addEventListener("click", () => {
           this.checkOutButton.classList.add("loading");
           this.checkOutButton.disabled = true;
           this.checkOutButton.innerHTML = "Redirecting to Checkout...";
           this.redirectToStripeCheckout();
          });
        }


      })
      .catch((err) => {
        // There was an error
        console.warn("Something went wrong.", err);
      });
  }
  async redirectToStripeCheckout() {
    const key = document.querySelector("html").dataset.stripekey;
    const url = document.querySelector("html").dataset.posturl;
    const stripe = Stripe(key);
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" }
      });

      const session = await response.json();
      if (session.id) {
        stripe.redirectToCheckout({ sessionId: session.id });
      } else {
        console.error("Session ID not received");
      }
    } catch (error) {
      console.error("Stripe Checkout error:", error);
    }
  }

  updateCount() {
    if (this.isupdating) {
      return false;
    }
    this.isupdating = true;
    // console.log("count");
    fetch(this.info_url)
      .then((response) => {
        // The API call was successful!
        return response.json();
      })
      .then((json) => {

        this.isupdating = false;
        // console.log(json);
        this.subtotal.innerHTML = json.total;
        this.cartCounter.innerHTML = json.item_count;
      })
      .catch((err) => {
        // There was an error
        console.warn("Something went wrong.", err);
      });
  }



  cartActions() {
    this.listItems = document.querySelectorAll(
      "[data-js='minicart-list-item']",
    );

    this.subtotal = document.querySelector("[data-js='minicart-subtotal']");
    this.listItems.forEach((listItem) => {
      const item = new ListItem(listItem);
      item.init();

    });

    /* Change Subtotal */
    window.addEventListener("cart-update", (event) => {
      this.updateCart();
      this.updateCount();
    });
  }

  init() {
    document.addEventListener("click", this.clickOutside.bind(this));

    window.addEventListener("add-to-cart", () => {
      this.open();
    });
    window.addEventListener("cart-empty", () => {
      this.updateCart();
      this.cartCounter.innerHTML = 0;
    });
    this.button.addEventListener("click", () => {
      this.isOpen ? this.close() : this.open();
    });

    this.closeButton.addEventListener("click", () => {
      this.close();
    });
  }

  open() {
    this.updateCart();
    this.isOpen = true;
    this.containerElement.scrollTop = 0;
    document.body.style.overflow = "hidden";
    this.container.classList.remove("hidden");

    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });
    gsap.set([this.container], {
      autoAlpha: 0,
    });

    gsap.set(this.containerElement, {
      xPercent: 100,
    });

    tl.to(this.container, {
      autoAlpha: 1,
      display: "flex",
    });

    tl.to(this.containerElement, {
      autoAlpha: 1,
      xPercent: 0,
    });
  }

  close() {
    this.isOpen = false;

    const tl = gsap.timeline({
      defaults: {
        duration: 0.2,
        ease: "power2.inOut",
      },
    });

    tl.to(this.containerElement, {
      xPercent: 100,
    });

    tl.to(this.container, {
      autoAlpha: 0,
      onComplete: () => {
        this.container.classList.add("hidden");
        document.body.style.overflow = "auto";
      },
    });
  }

  clickOutside(event) {
    if (
      this.isOpen &&
      event.target === this.container &&
      !this.containerElement.contains(event.target) &&
      !this.button.contains(event.target)
    ) {
      this.close();
    }
  }
}
